module.exports = __webpack_public_path__ + "static/Petal 0-eb478b7d7bd0bbcf2732975ca5c39f3e.png";